import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'ngx-update-menu',
  templateUrl: './update-menu.component.html',
  styleUrls: ['./update-menu.component.scss']
})
export class UpdateMenuComponent implements OnInit {
  @Input() id: number;
  closeResult: string;
  hideModal = false;
  hideLoader =true;
  hideButon = false;
  nom;
 
  
  constructor(private apiService:ApiService,private sendeurService:EventSendeurService,public toastr:NbToastrService) {
  
   }

  ngOnInit() {
    this.getOneMenu();
  }

  cancel(){

  }

  updateMenu(){
    this. hideLoader =false;
     this.hideButon = true;
     this.apiService.updateMenuProvider(this.nom,this.id).subscribe(data =>{
       this.toastr.success("Menu modifié avec success");
       this.hideModal = true;
     },(err) =>{
       console.log(err);
       this. hideLoader =true;
       this.hideButon = false;
       this.toastr.danger("echec, il se peut qu'un nom de menu similaire existe déjà");
     })
   }
 

   getOneMenu(){
     this.apiService.getOneMenuProvider(this.id).subscribe((data:any) =>{
       this.nom = data.nom
     })
   }


}
